import { APIClient } from "./APIClient"

export const JRAPIClient = new APIClient({
  audience: import.meta.env.VITE_JR_API_AUDIENCE
})
